import * as React from 'react';
import { FC, forwardRef } from 'react';

import { useLoyaltyBackground } from 'hooks/use-loyalty-background';

import { Wrapper } from './loyalty-background.styled';
import { ILoyaltyBackgroundProps } from './loyalty-background.types';

export const LoyaltyBackground: FC<ILoyaltyBackgroundProps> = forwardRef<
  HTMLDivElement,
  ILoyaltyBackgroundProps
>(
  (
    {
      bgImage,
      children,
      className,
      fullHeight,
      fixedHeight,
      scroll,
      onScroll,
      constrainToViewHeight,
    },
    ref
  ) => {
    const { image: defaultBgImage } = useLoyaltyBackground();

    return (
      <Wrapper
        data-testid="lyl-bg"
        className={className}
        $bgImage={bgImage || defaultBgImage}
        $constrainToViewHeight={constrainToViewHeight}
        $fullHeight={fullHeight}
        $fixedHeight={fixedHeight}
        $scroll={scroll}
        $withBackground={!!bgImage}
        onScroll={onScroll}
        ref={ref}
      >
        {children}
      </Wrapper>
    );
  }
);
